import { ILogEvent } from "../../interfaces/ILogEvent";
import { LogError } from "../../../utils/ErrorTelemetry";

export enum AudioBackupMethodStates {
    called = "called",
    continue = "continue",
    blocked = "blocked",
    upgradeneeded = "upgradeneeded",
    success = "success",
    complete = "complete"
};

export function AudioBackupLogError<T extends string>(logEvent: ILogEvent<T>, key: T, reason: string): Error {
    LogError(logEvent.GetEventName(), key + " failed. Reason: " + reason);
    return new Error(reason);
}
